import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * KeyTenants Widget
 */
@Component({
  selector: 'key-tenants-widget',
  templateUrl: './key-tenants-widget.component.html',
  styleUrls: ['./key-tenants-widget.component.scss']
})
export class KeyTenantsWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'keyTenants', false);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("keytenants", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = false;
    }
    this.mockupData$ = this.widgetService.loadMockup('keytenants');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('keytenants', this.getReport());
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Update Tenant Reversion
  * @param tenant {any} Tenant
   */
  updateTenantReversion(tenant: any) {
    setTimeout(() => {
      tenant.tenantReversion = parseFloat(tenant.tenantReversionCalc);
    });
  }

  /**
   * Update Total Reversion
   */
  updateTotalReversion() {
    setTimeout(() => {
      this.widgetData.totalReversion = parseFloat(this.widgetData.totalReversionCalc);
    });
  }
}

